/**
 * Assembly constructor.
 */
export abstract class Assembly extends Object {
	constructor() {
		super();
	}
}
